
const ActionRemarks = ({ 
    label = "Resolution Remarks *", 
    placeholder = "Please enter", 
    buttons = [] // e.g. [{label: 'Save As Draft', className: 'btn-danger light'}, {label: 'Submit Resolution', className: 'btn-primary'}]
}) => {
    return (
        <div className="action-remarks">
            <label className="form-label" style={{color: "#000"}}>{label}</label>
            <textarea 
                className="form-control" 
                placeholder={placeholder}
            ></textarea>
            
            {buttons && buttons.length > 0 && (
                <div className="action-buttons">
                    {buttons.map((btn, idx) => (
                        <button key={idx} className={`btn ${btn.className}`} onClick={btn.onClick}>
                            {btn.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ActionRemarks;
